<template>
    <component :is="baseComponent" :to="link.path ? link.path : '/'" :class="{ active: isActive }" tag="li">
        <a v-if="isMenu" data-toggle="collapse" href="#" @click.prevent="collapseMenu">
            <i :class="link.icon"></i>
            <p>
                {{ link.name }}
                <b :class="{ rotated: !collapsed }" class="caret"></b>
            </p>
        </a>
        <collapse-transition v-if="$slots.default || this.isMenu">
            <div v-show="!collapsed" class="collapse-menu">
                <ul class="nav">
                    <slot></slot>
                </ul>
            </div>
        </collapse-transition>
        <slot v-if="children.length === 0 && !$slots.default && link.path" name="title">
            <component
                :is="elementType(link, false)"
                :to="link.path"
                :class="{ active: link.active }"
                :target="link.target"
                :href="link.path"
                @click.native.stop="onItemClick"
            >
                <template v-if="addLink">
                    <div class="link-item d-flex">
                        <i v-if="link.icon" :class="link.icon"></i>
                        <span v-if="link.type" class="sidebar-mini-icon">{{ link.name.substring(0, 1) }}</span>
                        <span class="sidebar-normal flex-grow">{{ link.name }}</span>
                        <span v-if="link.type" class="item-close" @click="onRemoveUser($event)">
                            <i class="fa fa-close"></i>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <i :class="link.icon"></i>
                    <p>{{ link.name }}</p>
                </template>
            </component>
        </slot>
    </component>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions'
import SidebarLinks from '@/sidebarLinks'

export default {
    components: {
        CollapseTransition
    },
    props: {
        menu: {
            type: Boolean,
            default: false,
            description: 'Whether item is a menu containing multiple items'
        },
        link: {
            type: Object,
            default: () => {
                return {
                    name: '',
                    path: '',
                    children: []
                }
            },
            description: 'Link object'
        }
    },
    provide() {
        return {
            addLink: this.addChild,
            removeLink: this.removeChild
        }
    },
    inject: {
        addLink: { default: null },
        removeLink: { default: null },
        autoClose: { default: false }
    },
    data() {
        return {
            children: [],
            collapsed: true
        }
    },
    computed: {
        baseComponent() {
            return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
        },
        isMenu() {
            return this.children.length > 0 || this.menu === true
        },
        isActive() {
            if (this.$route) {
                let matchingRoute = this.children.find((c) => this.$route.path.startsWith(c.link.path))
                if (matchingRoute !== undefined) {
                    return true
                }
            }
            return false
        }
    },
    mounted() {
        if (this.addLink) {
            this.addLink(this)
        }
        if (this.link.collapsed !== undefined) {
            this.collapsed = this.link.collapsed
        }
        if (this.isActive && this.isMenu) {
            this.collapsed = false
        }
    },
    destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el)
        }
        if (this.removeLink) {
            this.removeLink(this)
        }
    },
    methods: {
        addChild(item) {
            const index = this.$slots.default.indexOf(item.$vnode)
            this.children.splice(index, 0, item)
        },
        removeChild(item) {
            const tabs = this.children
            const index = tabs.indexOf(item)
            tabs.splice(index, 1)
        },
        elementType(link, isParent = true) {
            if (link.isRoute === false) {
                return isParent ? 'li' : 'a'
            } else {
                return 'router-link'
            }
        },
        collapseMenu() {
            this.collapsed = !this.collapsed
        },
        onItemClick() {
            if (this.autoClose) {
                this.$sidebar.showSidebar = false
            }
        },
        onRemoveUser(e) {
            e.preventDefault()
            // SidebarLinks[1] Refers to USERS link group
            for (let i = 0; i <= SidebarLinks[1].children.length - 1; i++) {
                if (SidebarLinks[1].children[i].name === this.link.name) {
                    SidebarLinks[1].children.splice(i, 1)
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.caret.rotated {
    transform: rotate(180deg);
}
.sidebar .sidebar-wrapper > .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-normal {
    text-transform: none;
}
.sidebar .nav .item-close i {
    text-align: center;
    margin-right: 0;
}
.sidebar .nav li.active > a[data-toggle='collapse'] + div .nav .active a:after,
.sidebar .nav li.active > a[data-toggle='collapse'] i + div .nav .active a:after,
.sidebar .nav li.active > a[data-toggle='collapse'] ~ div > ul > li.active i + div .nav .active a:after,
.sidebar .nav li.active > a[data-toggle='collapse'] ~ div > ul > li.active > a + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle='collapse'] + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle='collapse'] i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle='collapse'] ~ div > ul > li.active i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle='collapse'] ~ div > ul > li.active > a + div .nav .active a:after {
    width: auto;
}
</style>
